module.exports = __webpack_public_path__ + "img/hire3x.2d754f4b.svg";